module.exports = "/_next/static/images/SubjectRightsManagement@2x-579d0774b1ccf1894e323a88a0e70721.webp";